import { gql } from '@apollo/client';
import { JobProfileModel, ClassificationModel, JobFamiliesModel } from '@utmost.co/enterprise-models';
import { JOB_PROFILE_MODEL_FRAGMENT } from 'src/graphql/features/jobProfiles/jobProfiles.fragment';

export interface EngagementJobProfile
  extends Pick<
    JobProfileModel,
    | 'code'
    | 'name'
    | 'displayName'
    | 'uid'
    | 'status'
    | 'assignable'
    | 'externalId'
    | 'description'
    | 'summary'
    | 'permissions'
    | 'countries'
    | 'jobFamily'
  > {
  mappedExportJobProfile: Pick<JobProfileModel, 'uid' | 'name'> | null;
  jobFamilies: Pick<JobFamiliesModel, 'items'>;
  classifications: Pick<ClassificationModel, 'uid' | 'name'>[];
  jobClassifications: Pick<ClassificationModel, 'uid' | 'name'>[];
}

export type EngagementClassification = Pick<ClassificationModel, 'name' | 'uid'>;

export interface UseGetEngagementsJobProfiles {
  jobProfiles: {
    totalCount: number;
    jobProfiles: EngagementJobProfile[];
  };
  totalCount: number;
}

export interface EngagementAllJobProfile {
  name: string;
  externalId: string;
  uid: string;
  mappedExportJobProfile: Pick<JobProfileModel, 'uid' | 'name'>;
}

export interface MappedJobProfilesData {
  jobProfiles: {
    jobProfiles: EngagementAllJobProfile[];
  };
}

export interface ClassificationsData {
  classifications: {
    classifications: EngagementClassification[];
  };
}

export const GET_MAPPED_JOB_PROFILES = gql`
  query GET_MAPPED_JOB_PROFILES($search: String, $limit: Int!, $offset: Int!) {
    jobProfiles(query: { classificationAssignable: false, search: $search }, page: { limit: $limit, offset: $offset }) {
      jobProfiles {
        name
        uid
        externalId
      }
    }
  }
`;

export const GET_CLASSIFICATIONS = gql`
  query GET_CLASSIFICATIONS {
    classifications {
      classifications {
        name
        uid
      }
    }
  }
`;

export const GET_ENGAGEMENTS_JOB_PROFILES = gql`
  query GET_ENGAGEMENTS_JOB_PROFILES($query: JobProfileQueryModelInput!, $page: PageModelInput) {
    jobProfiles(query: $query, page: $page) {
      totalCount
      limit
      offset
      jobProfiles {
        code
        name
        assignable
        uid
        displayName
        status
        externalId
        permissions
        mappedExportJobProfile {
          uid
          name
        }
        jobFamily {
          uid
          name
        }
        classifications {
          uid
          name
        }
        jobClassifications {
          uid
          name
        }
        description
        summary
        countries {
          code
          name
        }
      }
    }
  }
`;

export const REMOVE_JOB_PROFILE = gql`
  mutation REMOVE_JOB_PROFILE($uid: String!) {
    deleteJobProfile(uid: $uid)
  }
`;

export const CREATE_ENGAGEMENTS_JOB_PROFILE = gql`
  mutation CreateJobProfile($jobProfile: JobProfileCreateModelInput!) {
    jobProfile: createJobProfile(jobProfile: $jobProfile) {
      ...JobProfileModelFragment
    }
  }
  ${JOB_PROFILE_MODEL_FRAGMENT}
`;

export const UPDATE_ENGAGEMENTS_JOB_PROFILE = gql`
  mutation UpdateJobProfile($jobProfile: JobProfileUpdateModelInput!) {
    jobProfile: updateJobProfile(jobProfile: $jobProfile) {
      ...JobProfileModelFragment
    }
  }
  ${JOB_PROFILE_MODEL_FRAGMENT}
`;
